import getConfig from 'next/config';
import copy from '@/utils/copyTextToClipboard';
const config = getConfig() || {};
const publicRuntimeConfig = config.publicRuntimeConfig || {};
const PUBLIC_BASE_URL = publicRuntimeConfig.PUBLIC_BASE_URL || '';
// NOTE: sync with /functions/src/utils/widgets/createSnippet.ts
const TEMPLATE = `<excelkits-embed data-vendor="excelkits" data-widget="{{widgetId}}">
  <script src="{{BASE_PATH}}/_next/static/embeddables/excelkits-embed/index.js"></script>
</excelkits-embed>`;
export default function useCopyWidgetSnippet(widgetId, sendNotification) {
  const handleCopySnippet = async () => {
    try {
      await copy(parseEmbedTemplate(widgetId));
      sendNotification({
        description: 'Embed snippet is now copied to your clipboard',
        type: 'success'
      });
    } catch (err) {
      sendNotification({
        description: 'Failed to copy the embed snippet, please contact support',
        type: 'error'
      });
    }
  };

  return {
    handleCopySnippet
  };
} // Parse the template string with the
// current template and widget

function parseEmbedTemplate(widgetId) {
  return `${TEMPLATE}` // copy source
  .replace(/{{widgetId}}/g, widgetId).replace(/{{BASE_PATH}}/g, PUBLIC_BASE_URL);
}